/**
 * View image block.
 * @module components/manage/Blocks/Image/View
 */

import React from 'react';
import PropTypes from 'prop-types';
import { UniversalLink } from '@plone/volto/components';
import cx from 'classnames';
import { withBlockExtensions } from '@plone/volto/helpers';
import { flattenToAppURL, isInternalURL } from '@plone/volto/helpers';
import config from '@plone/volto/registry';


/**
 * View image block class.
 * @class View
 * @extends Component
 */
export const View = ({ data, detached, className }) => {
  const href = data?.href || '';
  return (
    <div
      className={cx(
        'block image align',
        {
          center: !Boolean(data.align),
          detached,
        },
        data.align,
        className,
      )}
    >
      {data.url && (
        <>
          {(() => {
            const image = (
              <figure
              className={cx(
                'figure',
                {
                  center: !Boolean(data.align),
                  detached,
                },
                data.align,
                {
                  'full-width': data.align === 'full',
                  large: data.size === 'l',
                  medium: data.size === 'm' || !data.size,
                  small: data.size === 's',
                },
              )}
            >
              <img
                loading="lazy"
                src={
                  isInternalURL(data.url)
                    ? // Backwards compat in the case that the block is storing the full server URL
                      (() => {
                        if (data.align === 'full') {
                          return `${flattenToAppURL(data.url)}/@@images/image`;
                        } else {
                          if (data.size === 'l') {
                            if (data.align === 'right' || data.align === 'left')
                              return `${flattenToAppURL(
                                data.url,
                              )}/@@images/image/teaser`;
                            else
                              return `${flattenToAppURL(
                                data.url,
                              )}/@@images/image/great`;
                          } else if (data.size === 'm') {
                            if (data.align === 'right' || data.align === 'left')
                              return `${flattenToAppURL(
                                data.url,
                              )}/@@images/image/preview`;
                            else
                              return `${flattenToAppURL(
                                data.url,
                              )}/@@images/image/teaser`;
                          } else if (data.size === 's') {
                            if (data.align === 'right' || data.align === 'left')
                              return `${flattenToAppURL(
                                data.url,
                              )}/@@images/image/mini`;
                            else
                              return `${flattenToAppURL(
                                data.url,
                              )}/@@images/image/preview`;
                          }

                          return `${flattenToAppURL(data.url)}/@@images/image`;
                        }
                      })()
                    : data.url
                }
                alt={data.alt || ''}
              />
              {data?.description && (
                <figcaption className="description">
                  {data?.description}
                </figcaption>
              )}
              {data?.rights && (
                <>
                  <figcaption
                    className={cx('copyright', {
                      nodescription: !data?.description,
                    })}
                  >
                    <em>Copyright: </em>
                  </figcaption>
                  <figcaption className="rights">
                    {config.settings.isHiERNProject === 'true' ? (
                      <em>{data?.rights}</em>
                    ) : (
                      <em>&mdash; {data?.rights}</em>
                    )}
                  </figcaption>
                </>
              )}
            </figure>
            );
            if (href) {
              return (
                <UniversalLink
                  href={href}
                  openLinkInNewTab={data.openLinkInNewTab}
                >
                  {image}
                </UniversalLink>
              );
            } else {
              return image;
            }
          })()}
        </>
      )}
    </div>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
View.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default withBlockExtensions(View);